import React, { useRef } from "react";
import Modal from "../Modal";
import CompanyTree from ".";
import { useTranslation } from "../../langs/useTranslation";
import { toast } from "../../apis/request";

export default function CompanyTreeModal({
  open,
  companyId,
  excludeKeys,
  checkable,
  checkStrictly,
  checkSeperatly,
  multiple,
  footer,
  onSelect,
  onClose,
  onConfirm
}) {
  const tree = useRef(null);
  const { t } = useTranslation();

  const handleConfirm = () => {
    if (tree.current.getCheckedKeys().length === 0) {
      return toast.warning(t({ defaultMessage: "不可全部取消勾选" }));
    }
    onConfirm?.(
      tree.current.getCheckedKeys(),
      tree.current.getExcludeKeys(),
      tree.current.getAllKeys()
    );
    onClose?.();
  };

  return (
    <Modal
      onClose={onClose}
      onConfirm={handleConfirm}
      closeable
      open={open}
      width={576}
      title={t({ defaultMessage: "选择公司" })}
      footer={footer}
    >
      <CompanyTree
        checkStrictly={checkStrictly}
        checkSeperatly={checkSeperatly}
        checkable={checkable}
        multiple={multiple}
        excludeKeys={excludeKeys}
        selectedKeys={[companyId]}
        onSelect={onSelect}
        ref={tree}
      />
    </Modal>
  );
}
